import { TFunction } from 'i18next'
import { BudgetCapping, DailyBudgetType } from '../../../../__generated__/graphql'
import { displayAsCurrency } from '../../../../utils/displayAsCurrency'
import { CampaignCreateAdgroupDraft } from './campaignCreateDrafts'

const formatAmount = (value: number | null | undefined): string => displayAsCurrency(value) ?? 'n/a'

export const getCampaignCreateAdgroupBudgetLines = (
  adgroup: CampaignCreateAdgroupDraft,
  t: TFunction
): Array<{ label: string; amount: string; type: string }> => [
  {
    label: t('adgroup.details.dailyBudgetWithCurrency'),
    amount: adgroup.dailyBudgetType === DailyBudgetType.Fixed ? formatAmount(adgroup.dailyBudget) : 'n/a',
    type: t(`adgroup.budgetAndDates.budgetType.${adgroup.dailyBudgetType}`),
  },
  {
    label: t('adgroup.budgetAndDates.budgetCapping'),
    amount: adgroup.budgetCappingType === BudgetCapping.Open ? 'n/a' : formatAmount(adgroup.budgetCapping),
    type: t(`enum.BudgetCapping.${adgroup.budgetCappingType}`),
  },
]
